import axios from "axios";
import { useEffect, useRef, useState } from "react";

const RppGenerator = () => {
  const [form, setForm] = useState({
    mapel: "",
    kelas: "",
    semester: "",
    fase: "",
    topik: "",
    waktu: "",
    tujuan: "",
    model: "",
    metode: "",
    media: "",
    profil: [],
    target: "",
  });
  const MAPEL_OPTIONS = {
    PAI: "Pendidikan Agama dan Budi Pekerti",
    PKN: "Pendidikan Pancasila",
    BIndo: "Bahasa Indonesia",
    MTK: "Matematika",
    IPA: "Ilmu Pengetahuan Alam",
    IPS: "Ilmu Pengetahuan Sosial",
    IPAS: "Ilmu Pengetahuan Alam dan Sosial",
    PJOK: "Pendidikan Jasmani Olahraga dan Kesehatan",
    SENIBUDAYA: "Seni dan Budaya",
    BIng: "Bahasa Inggris",
    MULOK: "Muatan Lokal",
    Koding: "Koding dan Kecerdasan Artifisial",
  };

  const MODEL_OPTIONS = [
    "Pembelajaran Berdiferensiasi",
    "Project Based Learning (PjBL)",
    "Problem Based Learning (PBL)",
    "Inquiry Learning",
    "Discovery Learning",
    "Cooperative Learning",
    "Teaching at the Right Level (TaRL)",
    "Blended Learning",
  ];

  const PROFIL_OPTIONS = [
    "Beriman, Bertakwa kepada Tuhan YME, dan Berakhlak Mulia",
    "Berkebinekaan Global",
    "Gotong Royong",
    "Mandiri",
    "Bernalar Kritis",
    "Kreatif",
  ];
  const [editableSections, setEditableSections] = useState({});
  const [sections, setSections] = useState({});
  const [loading, setLoading] = useState(false);
  const resultRef = useRef(null);
  const [user, setUser] = useState({});
  const [schoolData, setSchoolData] = useState([]);
  const [dataKepsek, setDataKepsek] = useState([]);
  const [showMapelOptions, setShowMapelOptions] = useState(false);

  const API_KEY = process.env.REACT_APP_OPENROUTER_API_KEY;
  const MODEL = process.env.REACT_APP_OPENROUTER_MODEL || "openai/gpt-4o-mini";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleProfilCheckbox = (e) => {
    const { value, checked } = e.target;

    setForm((prev) => {
      if (checked) {
        return { ...prev, profil: [...prev.profil, value] };
      } else {
        return {
          ...prev,
          profil: prev.profil.filter((item) => item !== value),
        };
      }
    });
  };

  const today = new Date();
  const formattedDate = today.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  useEffect(() => {
    setEditableSections(sections);
  }, [sections]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      axios
        .get(`${process.env.REACT_APP_API_URL}api/auth/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setUser(response.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);
  /* ================= FETCH DATA ================= */
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const token = localStorage.getItem("token");

        const [schoolRes, kepsekRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}api/datasekolah/all`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(
            `${process.env.REACT_APP_API_URL}api/auth/user-images-and-roles`,
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          ),
        ]);

        setSchoolData(schoolRes.data);
        setDataKepsek(
          kepsekRes.data.filter((user) => user.jabatan === "Kepala Sekolah"),
        );
      } catch (err) {
        console.error("Gagal mengambil data:", err);
      }
    };

    fetchAll();
  }, []);
  const formatKegiatanInti = (text) => {
    if (!text) return "";

    // Hapus teks (≥800 karakter)
    let cleaned = text.replace(/\(≥800 karakter\)/g, "");

    // Ubah **text** menjadi <strong>text</strong>
    cleaned = cleaned.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    return cleaned;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const prompt = `
Anda adalah penyusun Modul Ajar dan LKPD Sekolah Dasar.

TUGAS:
Buat RPP dan LKPD lengkap berdasarkan data yang diberikan.

FORMAT WAJIB DAN TIDAK BOLEH SALAH:

1. Jawaban HARUS dimulai dari nomor 1 dan berakhir di nomor 23.
2. Setiap nomor diawali dengan format: ANGKA + TITIK + SPASI
   Contoh:
   1. Isi jawaban
   2. Isi jawaban
3. Tidak boleh ada teks sebelum nomor 1.
4. Tidak boleh ada teks setelah nomor 23.
5. Tidak boleh ada nomor yang hilang atau lompat.
6. Tidak boleh mencampur isi antar nomor.
7. Tidak boleh menuliskan keterangan jumlah karakter.
8. Gunakan Bahasa Indonesia yang baik, sederhana, jelas, dan mudah dipahami guru SD.
9. Dilarang menggunakan bahasa asing.
10. Gunakan simbol perkalian (x), bukan huruf lain.
11. Guankan tugas-tugas yang sederhana dan mudah dipahami siswa SD.

=====================
ATURAN PANJANG KARAKTER
=====================

Nomor 10  : Minimal 800 karakter (8-12 poin diawali "- ")
Nomor 17  : Minimal 500 karakter maksimal 800 karakter
Nomor 22  : Minimal 400 karakter maksimal 600 karakter
Nomor lain: Maksimal 300 karakter

=====================
STRUKTUR RPP (1-13)
=====================

1. Kompetensi Awal
2. Penjelasan Dimensi Profil
3. KKTP
4. Asesmen Diagnostik
5. Asesmen Formatif
6. Asesmen Sumatif
7. Pemahaman Bermakna
8. Pertanyaan Pemantik
9. Deskripsi Pendahuluan
10. Deskripsi Kegiatan Inti (8-12 poin diawali "- ")
11. Deskripsi Penutup
12. Refleksi Peserta Didik
13. Refleksi Pendidik

=====================
STRUKTUR LKPD (14-23)
=====================

14. Petunjuk Belajar (100-300 karakter)
15. Kompetensi Dasar/Materi Pokok (100-300 karakter)
16. Informasi Pendukung (100-300 karakter)
17. Tugas/Langkah Kerja (500-800 karakter)
18. Pertanyaan (100-300 karakter)
19. Kesimpulan (100-300 karakter)
20. Kunci Jawaban Guru (100-300 karakter)
21. Pengayaan dan Remedial (200-400 karakter)

22. Rubrik Penilaian WAJIB dalam format tabel berikut:

Aspek | Skor 4 | Skor 3 | Skor 2 | Skor 1

ATURAN RUBRIK:
- Minimal 3 aspek penilaian
- Setiap baris dipisahkan dengan baris baru
- Setiap kolom dipisahkan dengan tanda "|"
- Tidak boleh ada teks tambahan
- Tidak boleh ada kalimat penjelasan sebelum atau sesudah tabel
- Isi harus sesuai dengan materi/topik

23. (Kosongkan atau tulis satu kalimat singkat penutup maksimal 100 karakter)

=====================
DATA
=====================

Mapel: ${form.mapel}
Kelas: ${form.kelas}
Semester: ${form.semester}
Topik: ${form.topik}
fase: ${form.fase}
Tujuan: ${form.tujuan}
Profil: ${form.profil.join(", ")}
Model: ${form.model}
Metode: ${form.metode}
Media: ${form.media}
Target: ${form.target}

Pastikan seluruh isi sesuai dengan topik yang diberikan.
`;

    try {
      const response = await fetch(
        "https://openrouter.ai/api/v1/chat/completions",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${API_KEY}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            model: MODEL,
            messages: [{ role: "user", content: prompt }],
          }),
        },
      );

      const data = await response.json();
      if (!response.ok)
        throw new Error(data.error?.message || "Terjadi kesalahan API");

      const text = data.choices?.[0]?.message?.content;
      if (!text) throw new Error("AI tidak mengembalikan teks");

      const splitData = text.split(/\n(?=\d+\.)/);
      const result = {};

      splitData.forEach((item) => {
        const number = item.match(/^(\d+)\./)?.[1];
        if (number) {
          result[number] = item.replace(/^\d+\.\s*/, "").trim();

          if (!["10", "17", "20", "21", "22"].includes(number)) {
            result[number] = result[number].slice(0, 300);
          }
        }
      });

      setSections(result);

      setTimeout(() => {
        resultRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } catch (err) {
      alert("ERROR: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const waktuTotal = parseInt(form.waktu) || 0;

  // Hitung awal (20% - 60% - 20%)
  let waktuPendahuluan = Math.round(waktuTotal * 0.2);
  let waktuPenutup = Math.round(waktuTotal * 0.2);

  // Batasi maksimal 18 menit
  waktuPendahuluan = Math.min(waktuPendahuluan, 18);
  waktuPenutup = Math.min(waktuPenutup, 18);

  // Sisa masuk ke inti
  const waktuInti = waktuTotal - waktuPendahuluan - waktuPenutup;

  const parseRubrik = (text) => {
    if (!text) return [];

    return text
      .split("\n")
      .map((row) => row.trim())
      .filter((row) => row.includes("|"))
      .map((row) => {
        const cols = row.split("|").map((col) => col.trim());
        if (cols.length === 5) return cols;
        return null;
      })
      .filter(Boolean);
  };
  const handleEdit = (key, value) => {
    setEditableSections((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const [editableRubrik, setEditableRubrik] = useState([]);
  useEffect(() => {
    if (sections["22"]) {
      setEditableRubrik(parseRubrik(sections["22"]));
    }
  }, [sections]);
  const handleRubrikEdit = (rowIndex, cellIndex, value) => {
    setEditableRubrik((prev) => {
      const updated = [...prev];
      updated[rowIndex][cellIndex] = value;
      return updated;
    });
  };

  return (
    <div className="p-6 bg-gray-200 min-h-screen">
      <div className="max-w-5xl mx-auto bg-white shadow-lg p-10 rounded">
        <h1 className="text-2xl font-bold text-center mb-6">MODUL AJAR</h1>

        {/* FORM */}
        <form
          onSubmit={handleSubmit}
          className="bg-white p-6 rounded-xl shadow-md space-y-6"
        >
          {/* GRID UTAMA */}
          <div className="grid md:grid-cols-2 gap-4">
            {/* MAPEL */}
            <div className="relative space-y-1">
              <label className="text-sm font-semibold">Mata Pelajaran</label>

              <div className="relative">
                <input
                  type="text"
                  name="mapel"
                  value={form.mapel}
                  onChange={handleChange}
                  onFocus={() => setShowMapelOptions(true)}
                  className="w-full border p-2 rounded text-sm pr-10"
                  placeholder="Pilih atau ketik mata pelajaran"
                />

                {/* ICON PANAH */}
                <button
                  type="button"
                  onClick={() => setShowMapelOptions(!showMapelOptions)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500"
                >
                  ▼
                </button>
              </div>

              {/* DROPDOWN CUSTOM */}
              {showMapelOptions && (
                <div className="absolute z-50 w-full bg-white border rounded shadow max-h-48 overflow-y-auto">
                  {Object.entries(MAPEL_OPTIONS).map(([key, value]) => (
                    <div
                      key={key}
                      onClick={() => {
                        setForm((prev) => ({ ...prev, mapel: value }));
                        setShowMapelOptions(false);
                      }}
                      className="p-2 text-sm hover:bg-blue-100 cursor-pointer"
                    >
                      {value}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* KELAS */}
            <div className="space-y-1">
              <label className="text-sm font-semibold">Kelas</label>
              <select
                name="kelas"
                value={form.kelas}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              >
                <option value="">Pilih Kelas</option>
                {[1, 2, 3, 4, 5, 6].map((k) => (
                  <option key={k} value={k}>
                    Kelas {k}
                  </option>
                ))}
              </select>
            </div>

            {/* SEMESTER */}
            <div className="space-y-1">
              <label className="text-sm font-semibold">Semester</label>
              <select
                name="semester"
                value={form.semester}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              >
                <option value="">Pilih Semester</option>
                <option value="1">Semester 1</option>
                <option value="2">Semester 2</option>
              </select>
            </div>

            {/* FASE */}
            <div className="space-y-1">
              <label className="text-sm font-semibold">Fase</label>
              <select
                name="fase"
                value={form.fase}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              >
                <option value="">Pilih Fase</option>
                <option value="A">Fase A</option>
                <option value="B">Fase B</option>
                <option value="C">Fase C</option>
              </select>
            </div>

            {/* TOPIK */}
            <div className="space-y-1 md:col-span-2">
              <label className="text-sm font-semibold">Topik</label>
              <textarea
                name="topik"
                value={form.topik}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              />
            </div>
            <div className="space-y-1 md:col-span-2">
              <label className="text-sm font-semibold">
                Tujuan Pembelajran
              </label>
              <textarea
                name="tujuan"
                value={form.tujuan}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              />
            </div>

            {/* WAKTU */}
            <div className="space-y-1">
              <label className="text-sm font-semibold">
                Alokasi Waktu (menit)
              </label>
              <input
                type="number"
                name="waktu"
                value={form.waktu}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              />
            </div>

            {/* MODEL */}
            <div className="space-y-1">
              <label className="text-sm font-semibold">
                Model Pembelajaran
              </label>
              <select
                name="model"
                value={form.model}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              >
                <option value="">Pilih Model</option>
                {MODEL_OPTIONS.map((m, i) => (
                  <option key={i} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>

            {/* METODE */}
            <div className="space-y-1 md:col-span-2">
              <label className="text-sm font-semibold">
                Metode Pembelajaran
              </label>
              <textarea
                name="metode"
                value={form.metode}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              />
            </div>

            {/* MEDIA */}
            <div className="space-y-1 md:col-span-2">
              <label className="text-sm font-semibold">
                Media Pembelajaran
              </label>
              <textarea
                name="media"
                value={form.media}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              />
            </div>

            {/* TARGET */}
            <div className="space-y-1 md:col-span-2">
              <label className="text-sm font-semibold">
                Target Peserta Didik
              </label>
              <input
                name="target"
                value={form.target}
                onChange={handleChange}
                className="w-full border p-2 rounded text-sm"
              />
            </div>

            {/* PROFIL */}
            <div className="md:col-span-2 space-y-2">
              <label className="text-sm font-semibold">
                Profil Pelajar Pancasila
              </label>

              <div className="grid md:grid-cols-2 gap-2 border p-3 rounded bg-gray-50">
                {PROFIL_OPTIONS.map((profil, index) => (
                  <label key={index} className="flex items-start gap-2 text-sm">
                    <input
                      type="checkbox"
                      value={profil}
                      checked={form.profil.includes(profil)}
                      onChange={handleProfilCheckbox}
                      className="mt-1"
                    />
                    {profil}
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 transition text-white py-3 rounded-lg font-semibold"
          >
            {loading ? "Memproses..." : "Generate Modul"}
          </button>
        </form>

        {/* HASIL */}
        {Object.keys(sections).length > 0 && (
          <div ref={resultRef} className="text-sm leading-relaxed print-area ">
            <Section title="Identitas">
              <p className="text-center font-bold text-lg uppercase">
                MODUL AJAR {form.mapel}
              </p>
              <p className="text-center font-bold mb-6">"{form.topik}"</p>

              <div className="grid grid-cols-[200px_10px_1fr] gap-y-1 text-sm">
                <div>Sekolah</div>
                <div>:</div>
                <div>{schoolData[0]?.namasekolah}</div>

                <div>Nama Guru</div>
                <div>:</div>
                <div>{user.name}</div>

                <div>Kelas</div>
                <div>:</div>
                <div>{form.kelas}</div>

                <div>Semester</div>
                <div>:</div>
                <div>{form.semester}</div>

                <div>Fase</div>
                <div>:</div>
                <div>{form.fase}</div>

                <div>Alokasi Waktu</div>
                <div>:</div>
                <div>{form.waktu} menit</div>

                <div>Target Peserta Didik</div>
                <div>:</div>
                <div>{form.target}</div>

                <div>Model Pembelajaran</div>
                <div>:</div>
                <div>{form.model}</div>
              </div>
            </Section>

            <Section title="Kompetensi Awal">
              <div
                contentEditable
                suppressContentEditableWarning
                onBlur={(e) => handleEdit("1", e.currentTarget.innerText)}
                className="outline-none"
              >
                {editableSections["1"]}
              </div>
            </Section>
            <Section title="Tujuan Pembelajaran">{form.tujuan}</Section>
            <Section title="Dimensi Profil Lulusan">
              <div
                contentEditable
                suppressContentEditableWarning
                onBlur={(e) => handleEdit("2", e.currentTarget.innerText)}
                className="outline-none"
              >
                {form.profil} — {sections["2"]}
              </div>
            </Section>

            <Section title="Sarana dan Prasarana">{form.media}</Section>

            <Section title="KKTP">{sections["3"]}</Section>

            <Section title="Asesmen">
              <ul className="list-disc ml-6">
                <li>
                  <b>Diagnostik:</b>
                  <span
                    contentEditable
                    suppressContentEditableWarning
                    onBlur={(e) => handleEdit("4", e.currentTarget.innerText)}
                    className="outline-none"
                  >
                    {sections["4"]}
                  </span>
                </li>
                <li>
                  <b>Formatif:</b>
                  <span
                    contentEditable
                    suppressContentEditableWarning
                    onBlur={(e) => handleEdit("5", e.currentTarget.innerText)}
                    className="outline-none"
                  >
                    {sections["5"]}
                  </span>
                </li>
                <li>
                  <b>Sumatif:</b>{" "}
                  <span
                    contentEditable
                    suppressContentEditableWarning
                    onBlur={(e) => handleEdit("6", e.currentTarget.innerText)}
                    className="outline-none"
                  >
                    {sections["6"]}
                  </span>
                </li>
              </ul>
            </Section>

            <Section title="Pemahaman Bermakna">
              <span
                contentEditable
                suppressContentEditableWarning
                onBlur={(e) => handleEdit("7", e.currentTarget.innerText)}
                className="outline-none"
              >
                {sections["7"]}
              </span>{" "}
            </Section>

            <Section title="Pertanyaan Pemantik">
              <span
                contentEditable
                suppressContentEditableWarning
                onBlur={(e) => handleEdit("8", e.currentTarget.innerText)}
                className="outline-none"
              >
                {sections["8"]}
              </span>{" "}
            </Section>

            <Section title="Kegiatan Pembelajaran">
              <table className="w-full border mt-4">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border p-2">Kegiatan</th>
                    <th className="border p-2">Deskripsi</th>
                    <th className="border p-2">Alokasi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border p-2">Pendahuluan</td>
                    <td className="border p-2">
                      <span
                        contentEditable
                        suppressContentEditableWarning
                        onBlur={(e) =>
                          handleEdit("9", e.currentTarget.innerText)
                        }
                        className="outline-none"
                      >
                        {sections["9"]}
                      </span>{" "}
                    </td>
                    <td className="border p-2">{waktuPendahuluan} menit</td>
                  </tr>

                  <tr>
                    <td className="border p-2">Kegiatan Inti</td>
                    <td
                      className="border p-2 whitespace-pre-line"
                      contentEditable
                      suppressContentEditableWarning
                      onBlur={(e) =>
                        handleEdit("10", e.currentTarget.innerHTML)
                      }
                      dangerouslySetInnerHTML={{
                        __html: editableSections["10"]
                          ? formatKegiatanInti(editableSections["10"])
                          : "",
                      }}
                    />
                    <td className="border p-2">{waktuInti} menit</td>
                  </tr>

                  <tr>
                    <td className="border p-2">Penutup</td>
                    <td className="border p-2">
                      <span
                        contentEditable
                        suppressContentEditableWarning
                        onBlur={(e) =>
                          handleEdit("11", e.currentTarget.innerText)
                        }
                        className="outline-none"
                      >
                        {sections["11"]}
                      </span>
                    </td>
                    <td className="border p-2">{waktuPenutup} menit</td>
                  </tr>
                </tbody>
              </table>
            </Section>

            <Section title="Refleksi">
              <p>
                <b>Peserta Didik:</b>{" "}
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("12", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["12"]}
                </span>
              </p>
              <p className="mt-2">
                <b>Pendidik:</b>{" "}
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("13", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["13"]}
                </span>
              </p>
            </Section>

            {/* ================= LKPD ================= */}
            <Section title="LEMBAR KERJA PESERTA DIDIK (LKPD)">
              <p>
                <b>Judul:</b> {form.topik}
              </p>

              <p className="mt-3">
                <b>Petunjuk Belajar:</b>
                <br />
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("14", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["14"]}
                </span>
              </p>

              <p className="mt-3">
                <b>Kompetensi Dasar/Materi Pokok:</b>
                <br />
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("15", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["15"]}
                </span>
              </p>

              <p className="mt-3">
                <b>Informasi Pendukung:</b>
                <br />
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("16", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["16"]}
                </span>
              </p>

              <p className="mt-3">
                <b>Tugas/Langkah Kerja:</b>
                <br />
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("17", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["17"]}
                </span>
              </p>

              <p className="mt-3">
                <b>Pertanyaan:</b>
                <br />
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("18", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["18"]}
                </span>
              </p>

              <p className="mt-3">
                <b>Kesimpulan:</b>
                <br />
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("19", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["19"]}
                </span>
              </p>

              <p className="mt-3">
                <b>Kunci Jawaban (Guru):</b>
                <br />
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("20", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["20"]}
                </span>
              </p>

              <p className="mt-3">
                <b>Pengayaan dan Remedial:</b>
                <br />
                <span
                  contentEditable
                  suppressContentEditableWarning
                  onBlur={(e) => handleEdit("21", e.currentTarget.innerText)}
                  className="outline-none"
                >
                  {sections["21"]}
                </span>
              </p>
            </Section>
            <Section title="Rubrik Penilaian">
              <table className="w-full border text-sm">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border p-2">Aspek</th>
                    <th className="border p-2">Sangat Baik</th>
                    <th className="border p-2">Baik</th>
                    <th className="border p-2">Cukup</th>
                    <th className="border p-2">Perlu Bimbingan</th>
                  </tr>
                </thead>
                <tbody>
                  {editableRubrik.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td
                          key={cellIndex}
                          className="border p-2"
                          contentEditable
                          suppressContentEditableWarning
                          onBlur={(e) =>
                            handleRubrikEdit(
                              rowIndex,
                              cellIndex,
                              e.currentTarget.innerText,
                            )
                          }
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </Section>
            {/* <p className="mt-3">
              <b>Pernyataan</b>
              <br />
              <span
                contentEditable
                suppressContentEditableWarning
                onBlur={(e) => handleEdit("23", e.currentTarget.innerText)}
                className="outline-none"
              >
                {sections["23"]}
              </span>
            </p> */}
            <div className="flex justify-between pt-10 px-7">
              <div>
                <br />
                <div>Guru Pengajar</div>
                <br />
                <br />
                <br />
                <div>
                  <p className="inline-block border-b border-black">
                    {user.name}
                  </p>
                </div>
                <div> NIP.{user.NIP}</div>
              </div>
              <div>
                <p>
                  {schoolData[0]?.ttDsekolah}, {formattedDate}
                </p>
                <div>Kepala Sekolah</div>
                <br />
                <br />
                <br />
                <div>
                  <p className="inline-block border-b border-black">
                    {dataKepsek[0]?.name}
                  </p>
                </div>
                <div>NIP.{dataKepsek[0]?.NIP}</div>
              </div>
            </div>
          </div>
        )}
      </div>
      <button
        onClick={() => window.print()}
        className="bg-green-600 text-white px-4 py-2 rounded mt-4"
      >
        Cetak / Simpan PDF
      </button>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h2 className="font-bold border-b pb-1 mb-2">{title}</h2>
    <div>{children}</div>
  </div>
);

export default RppGenerator;
